const rawColors = {
  green1: "#00D06C",
  green2: "#2FC799",
  blue1: "#37D5F7",
  purple1: "#C018EA",
  orange1: "#FC7819",
  red1: "#FC3E45",
};

const theme = {
  rawColors,
  colors: {
    primary: rawColors.green1,
  },
  fontSize: {
    xs: "14px",
    sm: "16px",
    md: "18px",
    lg: "20px",
    xl: "24px",
    xxl: "32px",
  },
};

export default theme;
